module.exports = __webpack_public_path__ + "img/filecoin.265bf362.svg";